module.exports = __webpack_public_path__ + "img/tour-31.85196408.png";